// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Daa-z","fadeIn":"Eaa-z","delay":"Faa-z","recommendedSizeTooltip":"Gaa-z"};